import { type ApolloError, useLazyQuery } from '@apollo/client';
import * as Sentry from '@sentry/react';

import LearnerObjectAttributesLearningGoalQuery from 'bundles/onboarding-common/queries/LearnerObjectAttributesLearningGoal.graphql';
import type {
  LearnerObjectAttributesLearningGoalQuery as LearnerObjectAttributesLearningGoalQueryType,
  LearnerObjectAttributesLearningGoalQueryVariables,
} from 'bundles/onboarding-common/queries/__generated__/LearnerObjectAttributesLearningGoal';
import { formatLearningGoalFromLearnerObject } from 'bundles/onboarding-common/utils/savedQuestionDataUtils';

const useFetchLearningGoalData = () => {
  const [fetchLearnerObjectData] = useLazyQuery<
    LearnerObjectAttributesLearningGoalQueryType,
    LearnerObjectAttributesLearningGoalQueryVariables
  >(LearnerObjectAttributesLearningGoalQuery, {
    context: { clientName: 'gatewayGql' },
    errorPolicy: 'all',
    fetchPolicy: 'network-only',
  });

  const handleError = (error: ApolloError | Error) => {
    Sentry.captureMessage('Error fetching learning goal data', {
      extra: {
        error: error.message,
      },
    });
  };

  const fetchLearningGoalData = async () => {
    try {
      const { data, error } = await fetchLearnerObjectData();

      if (error) {
        handleError(error);
        return null;
      }

      return formatLearningGoalFromLearnerObject(data);
    } catch (error) {
      handleError(error);

      return null;
    }
  };

  return {
    fetchLearningGoalData,
  };
};

export default useFetchLearningGoalData;
